import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#d1d9db", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 232 154"
      width={width}
      height={height}
    >
      <g id="ea60821e-9e1e-4bb8-8721-1885b22dbdbd" data-name="Слой 2">
        <g id="a1412362-0cd4-49a5-a328-031335e4b8b2" data-name="Слой 1">
          <g>
            <rect fill={fill} width="173" height="154" rx="32.2" />
            <path
              fill={fill}
              d="M217.2,129,185,109.5v-63l32.09-21.15c6-4,14.3-.26,14.87,6.88a8.31,8.31,0,0,1,0,.87v87.8a8.31,8.31,0,0,1,0,.87C231.39,128.84,223.27,132.63,217.2,129Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default memo(Icon);
